/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdMaterialsContent202,
  PostApiV1ClassroomdisciplineIdMaterialsContent400,
  PostApiV1ClassroomdisciplineIdMaterialsContent401,
  PostApiV1ClassroomdisciplineIdMaterialsContent404,
  PostApiV1ClassroomdisciplineIdMaterialsContentMutationRequest,
  PostApiV1ClassroomdisciplineIdMaterialsContentMutationResponse,
  PostApiV1ClassroomdisciplineIdMaterialsContentPathParams,
} from "../../types/classPlanningMaterialController/PostApiV1ClassroomdisciplineIdMaterialsContent.ts";
import { upsertMaterialContentRequestViewModelSchema } from "../upsertMaterialContentRequestViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdMaterialsContentPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContentPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdMaterialsContent202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContent202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineIdMaterialsContent400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContent400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdMaterialsContent401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContent401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdMaterialsContent404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContent404>;

export const postApiV1ClassroomdisciplineIdMaterialsContentMutationRequestSchema =
  z.lazy(
    () => upsertMaterialContentRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContentMutationRequest>;

export const postApiV1ClassroomdisciplineIdMaterialsContentMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdMaterialsContent202Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdMaterialsContentMutationResponse>;
